import { useContext } from 'react';
import { ActionTypes } from '../Store.d';
import { Context } from '../Store';

/**
 * Asks the use if they want to insert a voucher code.
 *
 * @returns {React.ReactNode | null}
 */
function VoucherPrompt() {
  const [ , dispatch ] = useContext(Context);

  return (
    <p>
      Sie haben einen{' '}
      <button
        className="link"
        onClick={() =>
          dispatch({
            type: ActionTypes.toggleVoucherInput,
            payload: true
          })
        }
        type="button"
      >
        Gutschein
      </button>
      ?
    </p>
  );
}

export { VoucherPrompt };
